import type { ReactNode } from 'react';

export const symbol_legend_toggle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-260h580q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H190q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5Zm0-170h580q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H190q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5Zm-15-194 191-116q15-9 33.5-8.5T432-737l168 119 152-108q15-11 31.5-2.75t16.5 27.89q0 7.86-3.5 13.86-3.5 6-9.5 11L635-568q-16 11-35 10.5T565-569L397-688 206-572q-15 9-30.5.32-15.5-8.67-15.5-26.02 0-8.3 4-14.8t11-11.5Z"
		/>
	</svg>
);
